import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Outlet,
} from 'react-router';

import Error from '@components/error';
// import Channels from '@pages/channels';
import Following from '@pages/following';
import Home from '@pages/home';
import Search from '@pages/search';
import Profile from '@pages/profile';
import Inbox from '@pages/inbox';
// import VerifyAccount from '@pages/verifyAccount';
import AppLayout from '@components/layouts/AppLayout';
import ShowInitialization from '@pages/liveShow/initialization';
import ShowRedirect from '@pages/showRedirect';
import LiveShow from '@pages/liveShow';
import RecordedShow from '@pages/recordedShow';
import ScheduledShow from '@pages/scheduledShow';
import {
  useCurrentShowId,
  useCurrentRecordedShowId,
} from '@redux/selectors/shows';
import LogIn from '@pages/auth/LogIn';
import SignUp from '@pages/auth/SignUp';
import ConfirmEmail from '@pages/auth/ConfirmEmail';
import ForgotPassword from '@pages/auth/ForgotPassword';
import SetPassword from '@pages/auth/SetPassword';
import Onboarding from '@pages/auth/Onboarding';
import OnboardingAvatarGeneration from '@pages/auth/OnboardingAvatarGeneration';
import { AuthProvider } from '@providers/AuthProvider';

import { RouteGuard } from './RouteGuard';
import AuthCallback from './AuthCallback';
import { APP_ROUTES, AUTH_ROUTES, AccessLevel } from './types';

const LiveShowRedirect = () => (
  <ShowRedirect
    useCurrentShowIdSelector={useCurrentShowId}
    ShowComponent={LiveShow}
  />
);

const RecordedShowRedirect = () => (
  <ShowRedirect
    useCurrentShowIdSelector={useCurrentRecordedShowId}
    ShowComponent={RecordedShow}
  />
);

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path='/'
      element={
        <AuthProvider>
          <Outlet />
        </AuthProvider>
      }
      errorElement={<Error />}
    >
      <Route
        path={AUTH_ROUTES.LOGIN}
        element={
          <RouteGuard accessLevel={AccessLevel.PUBLIC}>
            <LogIn />
          </RouteGuard>
        }
      />

      <Route
        path={AUTH_ROUTES.SIGN_UP}
        element={
          <RouteGuard accessLevel={AccessLevel.PUBLIC}>
            <SignUp />
          </RouteGuard>
        }
      />

      <Route path={AUTH_ROUTES.AUTH_CALLBACK} element={<AuthCallback />} />

      <Route
        path={AUTH_ROUTES.FORGOT_PASSWORD}
        element={
          <RouteGuard accessLevel={AccessLevel.PUBLIC}>
            <ForgotPassword />
          </RouteGuard>
        }
      />

      <Route
        path={AUTH_ROUTES.CONFIRM_EMAIL}
        element={
          <RouteGuard accessLevel={AccessLevel.ONBOARDING}>
            <ConfirmEmail />
          </RouteGuard>
        }
      />

      <Route
        path={AUTH_ROUTES.SET_PASSWORD}
        element={
          <RouteGuard accessLevel={AccessLevel.PASSWORD_RESET}>
            <SetPassword />
          </RouteGuard>
        }
      />

      <Route
        path={AUTH_ROUTES.ONBOARDING}
        element={
          <RouteGuard accessLevel={AccessLevel.ONBOARDING}>
            <Onboarding />
          </RouteGuard>
        }
      />

      <Route
        path={AUTH_ROUTES.ONBOARDING_AVATAR_GENERATION}
        element={
          <RouteGuard accessLevel={AccessLevel.AVATAR_FLOW}>
            <OnboardingAvatarGeneration />
          </RouteGuard>
        }
      />

      <Route
        path={APP_ROUTES.HOME}
        element={
          <RouteGuard accessLevel={AccessLevel.GUEST}>
            <AppLayout showSideMenu />
          </RouteGuard>
        }
      >
        <Route index element={<Home />} />
        <Route path={APP_ROUTES.SEARCH} element={<Search />} />
        {/* <Route path={APP_ROUTES.CHANNELS} element={<Channels />} /> */}
        <Route path={APP_ROUTES.FOLLOWING} element={<Following />} />
        {/* <Route path={APP_ROUTES.VERIFY_ACCOUNT} element={<VerifyAccount />} /> */}
      </Route>

      <Route
        path={APP_ROUTES.PROFILE}
        element={
          <RouteGuard accessLevel={AccessLevel.AUTHENTICATED}>
            <AppLayout showSideMenu />
          </RouteGuard>
        }
      >
        <Route path={`:id`} element={<Profile />} />
      </Route>

      <Route
        path={APP_ROUTES.INBOX}
        element={
          <RouteGuard accessLevel={AccessLevel.AUTHENTICATED}>
            <AppLayout showSideMenu />
          </RouteGuard>
        }
      >
        <Route index element={<Inbox />} />
      </Route>

      <Route
        path={APP_ROUTES.SHOWS}
        element={
          <RouteGuard accessLevel={AccessLevel.GUEST}>
            <AppLayout showSideMenu={false} hideHeaderAndBottomMenu />
          </RouteGuard>
        }
      >
        <Route
          path={APP_ROUTES.SHOWS_INITIALIZATION}
          element={<ShowInitialization />}
        />
      </Route>

      <Route
        path={`${APP_ROUTES.SHOW_LIVE}/:id`}
        element={
          <RouteGuard accessLevel={AccessLevel.GUEST}>
            <AppLayout showSideMenu={false} hideHeaderAndBottomMenu />
          </RouteGuard>
        }
      >
        <Route index element={<LiveShowRedirect />} />
      </Route>

      <Route
        path={`${APP_ROUTES.SHOW_RECORDED}/:id`}
        element={
          <RouteGuard accessLevel={AccessLevel.GUEST}>
            <AppLayout showSideMenu={false} hideHeaderAndBottomMenu />
          </RouteGuard>
        }
      >
        <Route index element={<RecordedShowRedirect />} />
      </Route>

      <Route
        path={`${APP_ROUTES.SHOW_SCHEDULED}/:id`}
        element={
          <RouteGuard accessLevel={AccessLevel.GUEST}>
            <AppLayout showSideMenu={false} hideHeaderAndBottomMenu />
          </RouteGuard>
        }
      >
        <Route index element={<ScheduledShow />} />
      </Route>
    </Route>,
  ),
);
